<template>
    <modal dialog="modal-lg" class="dark-top" :customClass="'heightAuto'" :footer="true">
        <div slot="title">
            <h2>New service</h2>
        </div>
        <div slot="body">
            <extra-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></extra-form>
        </div>

        <div slot="footer" class="d-flex flex-all">
            <button type="button" class="btn cancel wider" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled || getIsAddingItem">Save</button>
        </div>
    </modal>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Modal from './Modal'
    import ExtraForm from '@/components/inventory/extras/ExtraForm'

    export default {
        created: function () {
            this.clearSelectedExtra()
        },
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        computed: {
            ...mapGetters([
                'account',
                'getIsAddingItem'
            ])
        },
        methods: {
            ...mapActions([
                'clearSelectedExtra',
                'closeModal',
                'addItem'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            cancel: function() {
                this.closeModal();
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
            },
            save: function() {
                if (this.updatedForm) {
                    this.updatedForm.prices.map((price, index) => {
                        if(index > 0){ //prevents changing it self
                            price.vatType = this.updatedForm.prices[0].vatType
                            price.priceIncludeTaxes = this.updatedForm.prices[0].priceIncludeTaxes
                        }
                    })
                    this.addItem({
                        object: 'extra',
                        action: 'create',
                        table: 'extras',
                        fields: { supplierId: this.account.supplierId, extra: this.updatedForm }
                    });
                }
            }
        },
        components: {
            Modal,
            ExtraForm,
        }
    }
</script>



// WEBPACK FOOTER //
// ExtraAdd.vue?3f9e9167